export enum RegistrationStatus {
    PENDING = "PENDING",
    PROCESSED = "PROCESSED",
    REJECTED = "REJECTED",
}
